import { Component, Injector, OnInit } from '@angular/core';
import * as moment from 'moment';
import { EncounterService } from 'app/core/http/services/encounter.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'page-sidebar-schedule',
  templateUrl: './sidebar-schedule.component.html',
  styleUrls: ['./sidebar-schedule.component.scss'],
})
export class SidebarScheduleComponent extends BaseComponent implements OnInit {
  public title: string = 'Próximas agendas';
  public date: any = moment();
  public scheduleItens: any[] = [];
  public schedulesDay: any[] = [];
  public encounters: any[] = [];
  public userLogged = {
    name: '',
    entity_id: '',
    type: '',
  };

  constructor(private injector: Injector, private encounterService: EncounterService) {
    super(injector);
  }

  ngOnInit() {
    const user = this.currentUser.user;

    this.userLogged = {
      name: user,
      entity_id: user.id,
      type: this.currentUser.type,
    };

    if (localStorage.getItem('isFirstAccess') === 'false') {
      this.getAllEncounters();
    }
  }

  getAllEncounters() {
    let encounterService$;

    switch (this.userLogged?.type) {
      case 'organization':
        encounterService$ = this.encounterService.listByOrganization(this.userLogged.entity_id);
        break;
      case 'practitioner':
        encounterService$ = this.encounterService.listByPractitioner(this.userLogged.entity_id);
        break;
      case 'patient':
        encounterService$ = this.encounterService.listByPatient(this.userLogged.entity_id);
        break;
      default:
        encounterService$ = this.encounterService.listBySecretary(this.userLogged.entity_id);
        break;
    }

    encounterService$.subscribe({
      next: (resEncounter: any) => {
        this.encounters = this.transformObjectArray(resEncounter);
        this.loadCurrentDay();
      },
      error: (err: HttpErrorResponse) => {
        console.error(err.statusText);
      },
    });
  }

  transformObjectArray(input: any[]) {
    return input.map((item) => {
      const {
        encounter_id,
        type,
        status,
        specialty,
        serviceType,
        serviceCategory,
        serviceProvider,
        participant,
        subject,
        plannedStartDate,
        plannedEndDate,
        diagnosis,
        byOrderInfo,
      } = item;

      const organization = {
        name: serviceProvider.display,
        organization_id: serviceProvider.code,
      };

      const practitioner = {
        name: participant[0].display,
        practitioner_id: participant[0].code,
      };

      const patient = {
        name: subject.display,
        patient_name: subject.code,
      };

      return {
        encounter_id: encounter_id || null,
        type,
        status,
        specialty: specialty?.[0]?.coding?.[0]?.display,
        servicetype_name: serviceType?.[0]?.coding?.[0]?.display,
        servicecategory_name: serviceCategory?.[0]?.coding?.[0]?.display,
        organization,
        practitioner,
        patient,
        plannedStartDate: plannedStartDate,
        plannedEndDate: moment(plannedEndDate),
        diagnosis,
        byOrderInfo,
      };
    });
  }

  loadCurrentDay() {
    this.schedulesDay = this.encounters.filter((item: any) => moment().isSame(item.plannedStartDate, 'day'));
   
  }

  loadNextDay() {
    this.date.add(1, 'days');
    this.schedulesDay = this.encounters.filter((item: any) => this.date.isSame(item.plannedStartDate, 'day'));
  }

  loadPreviousDay() {
    this.date.subtract(1, 'days');
    this.schedulesDay = this.encounters.filter((item: any) => this.date.isSame(item.plannedStartDate, 'day'));
  }

  showPrevious() {
    return this.date.isAfter(moment());
  }

  dateFormat(date: any) {
    return moment(date, moment.ISO_8601).format('DD/MM/YYYY');
  }
}
